module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cars-list"
  }, _vm._l((_vm.cars), function(item) {
    return _c('div', {
      staticClass: "car-item-container"
    }, [_c('a', {
      attrs: {
        "href": item.href
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.goDetail(item)
        }
      }
    }, [_c("CarItem", {
      tag: "div",
      staticClass: "car-item",
      attrs: {
        "data": item
      }
    })])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bfd4edb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/ListMain/ListBox.vue
// module id = 881
// module chunks = 5